export default __webpack_public_path__ + "static/media/EA909430_tn.5738f73f.jpg";